import { ActionTypes } from "redux/reducers/wholesalerRetentions/types";
import { api_get, PROYECT } from "services/api";
import {
  setSnackbar,
  startRequestComp,
  stopRequestComp,
} from "../search/searchActions";

const {
  SET_RETENTIONS,
  SET_FILTERS,
  ADD_RETENTION,
  UPDATE_RETENTION_STATUS,
  REMOVE_RETENTION,
  SET_RETENTION_DETAILS,
  SET_RETENTION_BALANCE,
} = ActionTypes;

const mainUrl = `${process.env.REACT_APP_URL}${PROYECT}/retentions`;

export const getRetentions = ({
  station,
  month,
  year,
}) => async (dispatch) => {
  let url = `${mainUrl}/grouped-by-unit?idStation=${station?.id}`;
  if (month) url += `&month=${month}`;
  if (year) url += `&year=${year}`;
  dispatch(startRequestComp("loadingRetentions"));
  try {
    const resp = await api_get(url);
    if (resp.length === 0) {
      dispatch(setSnackbar("No se encontraron retenciones", "warning"));
    }
    dispatch({ type: SET_RETENTIONS, payload: resp });
  } catch (error) {
    dispatch(setSnackbar(error));
  } finally {
    dispatch(stopRequestComp("loadingRetentions"));
  }
};

export const getRetentionsByGroups = ({
  station,
  month,
  year,
  idCustomer
}) => async (dispatch) => {
  let url = `${mainUrl}?idStation=${station?.id}`;
  if (month) url += `&month=${month}`;
  if (year) url += `&year=${year}`;
  if (idCustomer) url += `&idCustomer=${idCustomer}`;
  dispatch(startRequestComp("loadingRetentionsByGroup"));
  try {
    const resp = await api_get(url);
    if (resp.length === 0) {
      dispatch(setSnackbar("No se encontraron retenciones", "warning"));
    }
    dispatch({ type: SET_RETENTION_DETAILS, payload: resp });
  } catch (error) {
    dispatch(setSnackbar(error));
  } finally {
    dispatch(stopRequestComp("loadingRetentionsByGroup"));
  }
};

export const setWholesalerRetentionsFilters = (key = "", value) => ({
  type: SET_FILTERS,
  payload: { key, value },
});

